import type { BaseSliceInitialState } from '../../Types/slices';
import { NetworkRequestState } from '../../Types/network';

const baseInitialState: BaseSliceInitialState<any> = {
    isEntitySlice: true,
    updatingById: {},
    deletingById: {},
    loadingById: {},
    create: { state: NetworkRequestState.Idle },

    pagination: {},
    paginationSequences: {},

    entities: {},
    ids: [],
};

export default baseInitialState;
